module.exports = __webpack_public_path__ + "media/images/flags/FM-0e440037fad555d2c946dfffd6846e3c.svg";